export const container = {
  position: "relative",
};

export const arrow = ({
  size = "medium", // medium | large
}) => ({
  alignSelf: "center",
  pointerEvents: "none",
  position: "absolute",
  top: "50%",
  right: size === "large" ? "30px" : "15px",
  width: size === "large" ? "24px" : "16px",
  transform: "translateY(-50%)",
});

export const selectTag = ({
  pl,
  size = "medium", // medium | large
}) => ({
  "select&": {
    appearance: "none",
    pr: size === "large" ? "84px" : "46px",
    pl,
    width: "100%",
    textOverflow: "ellipsis",
  },
});

export const label = ({
  size = "medium", // medium | large
}) => ({
  position: "absolute",
  left: "30px",
  top: "0",
  height: "100%",
  fontSize: size === "large" ? "30px" : "20px",
  fontWeight: "bold",
  letterSpacing: "0.025em",
  display: "flex",
  alignItems: "center",
});
